<template>
	<div class="cb-header__wrap cb-header__wrap--type3">
	    <div class="cb-header__title" :style="themeColor">
	    	{{header}}
	    </div>
	    <div class="cb-header__wizard" v-if="checkout_steps.length > 1">
	    	<div class="cb-header__button" :class="{'cb-header__button--active' : current_checkout_step == i}" :style="backgroundColor" v-for="i in checkout_steps" v-bind:key="i"></div>
	    </div>
	</div>
</template>

<script type="text/javascript">
	import { mapGetters } from "vuex"
	export default  {
		data() {
			return {
				editMode: false
			}
		},
		mounted() {
			this.editMode = this.$route.query.mode == "edit";
		},
		computed: {
			header() {
				if(this.$route.meta.headerTitle) {
					return this.$store.getters.translate(this.$route.meta.headerTitle.headerTitle);
				}
        return this.$store.getters.translate(this.editMode ? `${this.$route.name}.header.edit`: `${this.$route.name}.header`);
      },
      ...mapGetters([
      	"checkout_steps",
      	"current_checkout_step"
      ])
		}
	}
</script>
